export const sidebarContentStyles = {
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },

  mainDivider: {
    mx: 2,
    mb: 1,
  },

  // Navigation + System bölümünü birlikte saran kaydırılabilir alan
  scrollArea: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    // İnce scrollbar, sadece kaydırırken hafif görünür
    scrollbarWidth: 'thin',
    scrollbarColor: 'rgba(0,0,0,0.15) transparent',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'transparent',
      borderRadius: '3px',
      transition: 'background-color 0.2s ease',
    },
    '&:hover::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,0.15)',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
  },

  navigationContainer: {},

  systemSection: {
    pb: 1,
  },

  navigationList: {
    px: 0,
  },

  sectionDivider: {
    mx: 3,
    my: 2,
  },

  sectionLabel: {
    px: 3,
    fontSize: '0.8rem',
    fontWeight: 600,
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    display: 'block',
    mb: 1.5,
    color: 'text.secondary',
    opacity: 0.9,
  },

  footer: {
    p: 2,
    mt: 'auto',
    bgcolor: 'grey.100',
    backgroundImage:
      'linear-gradient(135deg, rgba(0,0,0,0.02) 0%, rgba(0,0,0,0.05) 100%)',
    boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
  },

  footerText: {
    fontSize: '0.75rem',
    display: 'block',
    textAlign: 'center',
    color: 'text.secondary',
    fontWeight: 600,
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    letterSpacing: '0.3px',
  },
};

export const menuItemStyles = {
  listItem: isActive => ({
    borderRadius: 2,
    mb: 0.5,
    mx: 1,
    cursor: 'pointer',
    bgcolor: isActive ? 'primary.main' : 'transparent',
    color: isActive ? 'primary.contrastText' : 'text.primary',
    py: 1.5,
    '&:hover': {
      bgcolor: isActive ? 'primary.dark' : 'grey.100',
      transform: 'translateX(4px)',
    },
    transition: 'all 0.2s ease-in-out',
    position: 'relative',
    overflow: 'hidden',
    '&::before': isActive
      ? {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '4px',
          bgcolor: 'primary.contrastText',
        }
      : {},
  }),

  listItemIcon: {
    color: 'inherit',
    minWidth: '44px',
    '& .MuiSvgIcon-root': {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
  },

  listItemText: isActive => ({
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: isActive ? 600 : 550,
    fontSize: '1rem',
    letterSpacing: '0.2px',
    lineHeight: 1.4,
  }),

  chip: {
    height: '22px',
    fontSize: '0.75rem',
    fontWeight: 700,
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    letterSpacing: '0.3px',
  },

  subItem: isActive => ({
    borderRadius: 2,
    mb: 0.5,
    mx: 1,
    cursor: 'pointer',
    bgcolor: isActive ? 'primary.main' : 'transparent',
    color: isActive ? 'primary.contrastText' : 'text.primary',
    py: 1,
    '&:hover': {
      bgcolor: isActive ? 'primary.dark' : 'grey.100',
      transform: 'translateX(4px)',
    },
    transition: 'all 0.2s ease-in-out',
    position: 'relative',
    overflow: 'hidden',
    '&::before': isActive
      ? {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '4px',
          bgcolor: 'primary.contrastText',
        }
      : {},
  }),

  subItemText: isActive => ({
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: isActive ? 600 : 550,
    fontSize: '0.95rem',
    letterSpacing: '0.2px',
    lineHeight: 1.4,
  }),

  subItemIcon: {
    color: 'inherit',
    minWidth: '36px',
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem',
      fontWeight: 500,
    },
  },
};
